module.exports = __webpack_public_path__ + "img/technology4.a4630467.png";